// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3h-P_","actions":"GroupTable_actions__218-y","deleteModalFooter":"GroupTable_deleteModalFooter__g-qG0"};